class ActivityNotifications
  constructor: ->
    @bindElements()

  bindElements: ->
    $(".notification-feed").on "click", ".notification.unread", (e) ->
      unless $(e.target).hasClass("review-link")
        $(this).removeClass("unread").addClass("read")

        # TO DO: // ujs refactor
        # This should really use the link directly. However the element contains
        # sub-links that can't be wrapped. We should rethink this UI patern.
        $(this).next(".mark-as-read-trigger").get(0).click()

$(document).on 'turbo:load', ->
  new ActivityNotifications()
